import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  height: 100%;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: inline-block;\n  cursor: pointer;\n  border: 0;\n  padding: 0;\n  background: transparent;\n\n  &:focus {\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import FocusTrap from "../focus-trap/FocusTrap";
import { VisuallyHidden } from "../text";
var IconButtonBase = /*#__PURE__*/ React.forwardRef(function(_param, ref) {
    var label = _param.label, href = _param.href, onClick = _param.onClick, disabled = _param.disabled, icon = _param.icon, props = _object_without_properties(_param, [
        "label",
        "href",
        "onClick",
        "disabled",
        "icon"
    ]);
    var elementProps = _object_spread({
        onClick: !disabled ? onClick : undefined
    }, props);
    var content = /*#__PURE__*/ _jsxs(IconButtonInner, {
        children: [
            icon,
            /*#__PURE__*/ _jsx(VisuallyHidden, {
                children: label
            })
        ]
    });
    if (href && !disabled) {
        return /*#__PURE__*/ _jsx("a", _object_spread_props(_object_spread({}, elementProps), {
            ref: ref,
            href: href,
            children: content
        }));
    }
    return /*#__PURE__*/ _jsx("button", _object_spread_props(_object_spread({}, elementProps), {
        ref: ref,
        type: "button",
        disabled: disabled,
        children: content
    }));
});
IconButtonBase.displayName = "IconButtonBase";
var IconButtonInner = styled(FocusTrap).withConfig({
    componentId: "sc-868f5b96-0"
})(_templateObject());
var IconButton = styled(IconButtonBase).withConfig({
    componentId: "sc-868f5b96-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.normalizeStyles(_object_spread({}, theme.focus.outlines.withOffset));
}, function(param) {
    var $styles = param.$styles, theme = param.theme;
    return theme.normalizeStyles($styles);
});
export default IconButton;
